export interface GraphNode {
  id: number | string;
  name: string;
  type: string;
  documents?: number[];
}

export interface GraphEdge {
  id: number | string;
  sourceId: number | string;
  targetId: number | string;
  type: string;
  documents?: number[];
}

export interface GraphData {
  nodes: GraphNode[];
  edges: GraphEdge[];
}

// Base colors
export const ENTITY_COLORS: Record<string, string> = {
  PERSON: '#2196F3',
  ORGANIZATION: '#4CAF50',
  LOCATION: '#FF9800',
  TECHNOLOGY: '#9C27B0',
  CONCEPT: '#00BCD4',
  EVENT: '#F44336',

  COMPLIANCE_STANDARD: '#607D8B',
  GROUP: '#795548',
  INITIATIVE: '#3F51B5',
};
